// The IR blaster's screen on the phone — DeviceID 19 (and 57 / 62).
//
// Chrome only. Every key, every literal and every rule lives in
// core/devices/irRemote + core/hooks/useIrRemote, and the pads themselves are
// ui/shared/remote/RemotePads, so the desktop shows the identical remote.
//
// Before this existed, a blaster fell through DeviceScreen's `default` to the
// generic output-driven controls — and a blaster has no outputs, so it read
// "No controllable outputs found." about a device that works.

import React from 'react';
import { Box, useTheme } from '@mui/material';
import DeviceAppBar from './components/DeviceAppBar';
import RemoteHandset from '../../../shared/remote/RemoteHandset';

export default function IrRemoteScreen({ device }) {
  const theme = useTheme();
  const c = theme.sli;

  return (
    <Box sx={{
      height: '100%', bgcolor: c.back, display: 'flex', flexDirection: 'column',
    }}
    >
      <DeviceAppBar device={device} subtitle={device?.LocationName ?? ''} />
      {/* Inline, not floating: a phone is already the shape of a handset, so
          the body fills the screen and its tab bar lands under the thumb. No ×
          either — the app bar's back arrow is the way out here. */}
      <Box sx={{
        flex: 1, minHeight: 0, p: 1, display: 'flex', justifyContent: 'center',
      }}
      >
        <RemoteHandset
          uniqueNumber={device?.UniqueNumber}
          deviceName={device?.DeviceName || device?.UniqueNumber}
          initialStatus={device?.Status || ''}
        />
      </Box>
    </Box>
  );
}
